import React, { useEffect } from 'react'
import { Switch, Table, Tooltip } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useSupplierModel } from '../supplierModel'
import { ISupplierDetail } from '../supplierTypes'
import YhTootip from '@/components/YhTootip'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys, onEnableChange } = useSupplierModel()

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISupplierDetail> = [
        {
            title: '序号',
            width: 40,
            align: 'left',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '供应商编码',
            align: 'left',
            dataIndex: 'code',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '供应商名称',
            align: 'left',
            dataIndex: 'name',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '创建人',
            align: 'left',
            dataIndex: 'createUser',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '创建时间',
            align: 'left',
            dataIndex: 'createTime',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '操作',
            width: 40,
            align: 'left',
            dataIndex: 'code',
            fixed: 'right',
            render: (text: string, record:ISupplierDetail ) => (
                <Switch
                    checked={+record.enable ? false : true}
                    onChange={(checked: boolean, e: MouseEvent) => {
                        e.stopPropagation()
                        onEnableChange(record.id, checked ? 0 : 1)
                    }}
                />
            ),
        },
    ]


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id)
        let newSelectedRowKeys = [...selectedRowKeys]
        if (findIndex === -1) {
            newSelectedRowKeys.push(id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            newSelectedRowKeys.splice(findIndex, 1)
            setSelectedRowKeys(newSelectedRowKeys)
        }
    }

    return (
        <Table
            rowKey={(record) => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map((item) => item.id)
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter((item) => changeRowId.indexOf(item) < 0))
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys,
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomCenter'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
            }}
            onRow={(record) => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record.id])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 446px)' }}
        />
    )
}
